import Vue from 'vue';

export const uploadFile = ({ commit }, file) => {
  return new Promise((resolve, reject) => {
    Vue.http.post('upload', file).then(({ body }) => {
      console.log('body', body);
      resolve(body);
    }, (error) => {
      reject(error);
    });
  });
};

export const uploadImage = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    Vue.http.post('uploadImgBase64', {
      imageUrl: data.url
    }).then(({ body }) => {
      resolve(body);
    }, (error) => {
      reject(error);
    });
  });
};



// WEBPACK FOOTER //
// ./src/store/actions.js